<template>
  <div>
    <div class="landscape">
      <div class="spaceshipHall">
        <transition name="fade">
          <div class="main-hall-glow glowing-mobile" v-show="isMobile"></div>
        </transition>

        <transition name="fade">
          <div class="onConsole" v-show="onConsole"></div>
        </transition>

        <transition name="fade">
          <div class="todojo" v-show="todojo"></div>
        </transition>

        <transition name="fade">
          <div class="tomaproom" v-show="tomaproom"></div>
        </transition>

        <transition name="fade">
          <div class="tochill" v-show="tochill"></div>
        </transition>

        <router-link to="/maproom">
          <div
            class="maproom"
            :class="{ cursorLeft: tomaproom }"
            @mouseover="
              tomaproom = true;
              $store.commit('setToPlace', 'to_map_room');
            "
            @mouseleave="
              tomaproom = false;
              $store.commit('setToPlace', '...');
            "
          ></div>
        </router-link>

        <router-link to="/corridor-dojo">
          <div
            class="dojo"
            :class="{ cursorRight: todojo }"
            @mouseover="
              todojo = true;
              $store.commit('setToPlace', 'to_dojo');
            "
            @mouseleave="
              todojo = false;
              $store.commit('setToPlace', '...');
            "
          ></div>
        </router-link>

        <router-link to="/corridor-chill">
          <div
            class="chill"
            :class="{ cursorRight: tochill }"
            @mouseover="
              tochill = true;
              $store.commit('setToPlace', 'to_aisle_B');
            "
            @mouseleave="
              tochill = false;
              $store.commit('setToPlace', '...');
            "
          ></div>
        </router-link>

        <div
          class="console"
          @mouseover="
            onConsole = true;
            $store.commit('setToPlace', 'check_main_console');
          "
          @mouseleave="
            onConsole = false;
            $store.commit('setToPlace', '...');
          "
          @click="toggleConsole()"
        ></div>
        <MainConsole
          @closePopup="toggleConsole"
          v-if="showConsole"
        ></MainConsole>
      </div>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import MainConsole from "./MainConsole";
import MainMixin from "@/components/utilities/MainMixin.vue";
import NotOriented from "@/components/mobile/NotOriented.vue";
export default {
  name: "MainHall",
  title: "Main Hall",
  components: {
    MainConsole,
    NotOriented,
  },
  mixins: [MainMixin],
  data() {
    return {
      todojo: false,
      tomaproom: false,
      onConsole: false,
      showConsole: false,
      tochill: false,
    };
  },
  methods: {
    toggleConsole() {
      this.$store.commit("focusOnStuff");
      this.showConsole = !this.showConsole;
    },
  },
  mounted() {
    this.init();
    if (Object.keys(this.$route.params).length !== 0) {
      this.toggleConsole();
    }
    let newMsg = {
      text:
        "Oi, oi captain! Take a chill pill in the ship, click_on (or) touch shit to find the good stuff.",
      delay: 4000,
    };
    this.$store.commit("setWanerMsg", newMsg);
  },
};
</script>

<style lang="scss" scoped>
body,
html {
  background-color: black;
}

.spaceshipHall {
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/hall1.png");
  background-size: 100vw 100vh;
  background-color: black;
}

.main-hall-glow {
  position: absolute;

  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/main-hall-glow.jpg");
  background-size: 100vw 100vh;
  background-color: black;
}

.dojo {
  position: absolute;
  top: 35vh;
  height: 38vh;
  width: 10vw;
  right: 24vw;
}

.todojo {
  position: absolute;

  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/todojo.png");
  background-size: 100vw 100vh;
}

.maproom {
  position: absolute;
  top: 35vh;
  height: 40vh;
  width: 8vw;
  left: 18vw;
}

.tomaproom {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/tomaproom.jpg");
  background-size: 100vw 100vh;
}

.chill {
  position: absolute;
  top: 35vh;
  height: 40vh;
  width: 10vw;
  right: 5vw;
}

.tochill {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/tochill.jpg");
  background-size: 100vw 100vh;
}

.onConsole {
  position: absolute;
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/console.png");
  background-size: 100vw 100vh;
}

.console {
  position: absolute;
  bottom: 15vh;
  height: 38vh;
  width: 22vw;
  left: 42vw;
}
</style>
